import React, { useRef, useEffect, useState } from "react"
import CustomLink from "./CustomLink"

const DerviedTable = (props) => {
   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)

   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name)
         }, 1000) // Add a 1-second delay

         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay)
      }
   }, [changeOccure, props.name, props.handleDiffCategory])

   var numRows = 0
   var prevNumRows = 0
   const [data, setData] = useState()
   const [previousData, setPreviousData] = useState()

   useEffect(() => {
      if (props.data) {
         setData(props.data.sort())
      }
      if (props.previousData) {
         setPreviousData(props.previousData.sort())
      }
   }, [props.data, props.previousData])

   if (data != null && data.length > 0) {
      numRows = data.length
   }

   if (previousData != null && previousData.length > 0) {
      prevNumRows = previousData.length
   }

   const containerRef = useRef(null)
   const table1Ref = useRef(null)
   const table2Ref = useRef(null)

   useEffect(() => {
      const synchronizeRowHeights = () => {
         const table1Rows = table1Ref.current?.querySelectorAll("tbody tr") || []
         const table2Rows = table2Ref.current?.querySelectorAll("tbody tr") || []

         // Ensure both tables have the same number of rows
         const rowCount = Math.max(table1Rows.length, table2Rows.length)

         for (let i = 0; i < rowCount; i++) {
            const table1Row = table1Rows[i]
            const table2Row = table2Rows[i]

            if (table1Row && table2Row) {
               // Get the maximum height of the two rows
               const maxHeight = Math.max(table1Row.offsetHeight, table2Row.offsetHeight)

               // Apply the maximum height to both rows
               table1Row.style.height = `${maxHeight}px`
               table2Row.style.height = `${maxHeight}px`
            }
         }
      }

      // Synchronize row heights initially
      synchronizeRowHeights()

      // Synchronize row heights on window resize
      window.addEventListener("resize", synchronizeRowHeights)

      return () => {
         window.removeEventListener("resize", synchronizeRowHeights)
      }
   }, [data, previousData])

   useEffect(() => {
      let isSyncing = false

      const handleScrollTable1 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop || 0
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const handleScrollTable2 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table1Ref.current) {
            table1Ref.current.scrollTop = table2Ref.current.scrollTop || 0
            table1Ref.current.scrollLeft = table2Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const table1 = table1Ref.current
      const table2 = table2Ref.current

      if (table1) {
         table1.addEventListener("scroll", handleScrollTable1)
      }

      if (table2) {
         table2.addEventListener("scroll", handleScrollTable2)
      }

      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScrollTable1)
         }
         if (table2) {
            table2.removeEventListener("scroll", handleScrollTable2)
         }
      }
   }, [data, previousData])

   const getHeader = () => {
      var keys = getKeys()
      return keys.map((key, index) => {
         if (
            key.toLowerCase() === "derivedid" ||
            key.toLowerCase() === "derivedlink" ||
            key.toLowerCase() === "sourceid" ||
            key.toLowerCase() === "sourcelink"
         ) {
            return null
         }
         return (
            <th key={key}>
               <span>{key}</span>
            </th>
         )
      })
   }

   const compareObjects = (current, previous, parentKey = "") => {
      let differences = {}

      if (
         typeof current === "object" &&
         current !== null &&
         typeof previous === "object" &&
         previous !== null
      ) {
         // If both are objects, compare their keys recursively
         const keys = new Set([...Object.keys(current), ...Object.keys(previous)])
         keys.forEach((key) => {
            const newKey = parentKey ? `${parentKey}.${key}` : key // Flatten the key
            Object.assign(
               differences,
               compareObjects(current[key], previous[key], newKey)
            )
         })
      } else {
         // For primitive values, compare directly
         const flattenedKey = parentKey
         differences[flattenedKey] = current === previous ? "same" : "different"
      }

      return differences
   }

   const differencesInEachRow = (index) => {
      let differencesInRow = {}
      // Ensure both rows exist
      if (data[index] && previousData[index]) {
         // Check if the current row is empty
         const isCurrRowEmpty = Object.values(data[index]).every((value) => {
            if (typeof value === "object" && value !== null) {
               // Check if sub-object is empty
               return Object.values(value).every((subValue) => !subValue)
            }
            return !value // Check if the value itself is empty
         })

         // Check if the previous row is empty
         const isPrevRowEmpty = Object.values(previousData[index]).every((value) => {
            if (typeof value === "object" && value !== null) {
               // Check if sub-object is empty
               return Object.values(value).every((subValue) => !subValue)
            }
            return !value // Check if the value itself is empty
         })

         // Perform comparison only if both rows are not empty
         if (!isCurrRowEmpty && !isPrevRowEmpty) {
            differencesInRow = compareObjects(data[index], previousData[index])
         }
      }

      return differencesInRow
   }

   const getRowsData = (data) => {
      var items = data
      var keys = getKeys()
      let backgroundColor = ""

      return items.map((row, index) => {
         // Check if the row or its sub-objects are empty
         const isRowEmpty =
            !row ||
            Object.values(row).every((value) => {
               if (typeof value === "object" && value !== null) {
                  // Check if sub-object is empty
                  return Object.values(value).every((subValue) => !subValue)
               }
               return !value // Check if the value itself is empty
            })

         if (isRowEmpty) {
            // Render an empty row
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
               <tr key={index}>
                  <td
                     colSpan={keys.length}
                     style={{
                        backgroundColor: "#ffcccc",
                        width: "60px",
                        height: "60px",
                        textAlign: "center",
                        verticalAlign: "middle",
                     }}
                  ></td>
               </tr>
            )
         }
         let differencesInRow = differencesInEachRow(index)

         if (Object.values(differencesInRow).includes("different")) {
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            backgroundColor = "#ffcccc"
         } else {
            backgroundColor = "white"
         }
         return (
            <tr key={index} style={{ backgroundColor: backgroundColor }}>
               <RenderRow
                  key={index}
                  data={row}
                  keys={keys}
                  differencesInRow={differencesInRow}
               />
            </tr>
         )
      })
   }

   const getKeys = function () {
      return Object.keys(data[0])
   }

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const RenderColumn = function (props) {
      return props.keys.map((key, index) => {
         return (
            <div key={index}>
               <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
               <span>{props.data[key]}</span>
            </div>
         )
      })
   }

   const RenderRow = (props) => {
      return props.keys.map((key, index) => {
         if (props.data[key] != null && typeof props.data[key] === "object") {
            var colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn data={props.data[key]} keys={colKeys} />
               </td>
            )
         } else if (
            key.toLowerCase().trim() === "derived name" &&
            props.data["derivedid"] &&
            props.data["derivedid"].toLowerCase().trim() !== "no access"
         ) {
            var name = props.data[key]
            return (
               <td style={{ minWidth: "9rem" }} key={index}>
                  {props.data["derivedlink"] != null &&
                  props.data["derivedlink"] !== "" ? (
                     <CustomLink
                        id={props.data["derivedid"]}
                        link={props.data["derivedlink"]}
                        name={name}
                     />
                  ) : (
                     <span>{name}</span>
                  )}
               </td>
            )
         } else if (
            key.toLowerCase().trim() === "source name" &&
            props.data["sourceid"] &&
            props.data["sourceid"].toLowerCase().trim() !== "no access"
         ) {
            var source_Name = props.data[key]
            return (
               <td style={{ minWidth: "9rem" }} key={index}>
                  {props.data["sourcelink"] != null && props.data["sourcelink"] !== "" ? (
                     <CustomLink
                        id={props.data["sourceid"]}
                        link={props.data["sourcelink"]}
                        name={source_Name}
                     />
                  ) : (
                     <span>{source_Name}</span>
                  )}
               </td>
            )
         } else if (
            key.toLowerCase() === "derivedid" ||
            key.toLowerCase() === "derivedlink" ||
            key.toLowerCase() === "sourceid" ||
            key.toLowerCase() === "sourcelink"
         ) {
            return null
         } else {
            if (props.differencesInRow) {
               if (props.differencesInRow[key] === "different") {
                  return (
                     <td key={index} style={{ color: "red", fontWeight: "bold" }}>
                        {props.data[key]}
                     </td>
                  )
               }
            }
            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   return (
      <div className="tableFixHead">
         <div ref={containerRef} style={{ display: "flex" }}>
            <div
               ref={table1Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["releaseRevision"]}
                  </div>
               )}
               {numRows > 0 && (
                  <table className="tableBorder">
                     <thead>
                        <tr>
                           <th style={{ backgroundColor: "white" }}>
                              <span>{props.derived}</span>
                           </th>
                        </tr>
                        <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                     </thead>
                     <tbody>{getRowsData(data)}</tbody>
                  </table>
               )}
            </div>
            <div
               ref={table2Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["obsoleteRevision"]}
                  </div>
               )}
               {prevNumRows > 0 && (
                  <table className="tableBorder">
                     <thead>
                        <tr>
                           <th style={{ backgroundColor: "white" }}>
                              <span>{props.derived}</span>
                           </th>
                        </tr>
                        <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                     </thead>
                     <tbody>{getRowsData(previousData)}</tbody>
                  </table>
               )}
            </div>
         </div>
      </div>
   )
}
export default DerviedTable
